import React from "react"
import styled from "styled-components"
import { breakpoints } from "../style/theme"

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 6rem 0;
  @media screen and (max-width: ${breakpoints.sm - 1}px) {
    flex-direction: column;
  }
`

const Chart = styled.div`
  position: relative;
  margin-right: auto;
  margin-left: auto;
  width: 280px;
  height: 280px;
  background-image: conic-gradient(${props => props.third} 0% 33%, ${props => props.second} 33% 66%, ${props => props.first} 66% 100%);
  border-radius: 50%;
`

const First = styled.span`
  position: absolute;
  top: 30%;
  left: 50px;
  transform: translateY(-50%);
  color: #fff;
  font-size: 1.0rem; 
  mix-blend-mode: difference;
`

const Second = styled.span`
  position: absolute;
  bottom: 10%;
  right: 0;
  left: 0;
  text-align: center;
  transform: translateY(-50%);
  color: #fff;
  font-size: 1.0rem; 
  mix-blend-mode: difference;
`

const Third = styled.span`
  position: absolute;
  top: 30%;
  right: 50px;
  transform: translateY(-50%);
  color: #fff;
  font-size: 1.0rem; 
  mix-blend-mode: difference;
`

const ColorsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem auto;
`

const ColorWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0 4rem;
`

const ColorBox = styled.div`
  width: 32px;
  height: 32px;
  background-color: ${props => props.color};
`

const Color = styled.span`
  margin: 0.25rem auto 0.25rem 0.25rem;
`

export const ColorChart = ({first="#ff0000", second="#00ff00", third="#0000ff"}) => {
  return (
    <Wrapper>
      <Chart first={first} second={second} third={third}>
        <First>{first}</First>
        <Second>{second}</Second>
        <Third>{third}</Third>
      </Chart>
      <ColorsWrapper>
        <ColorWrapper>
          <ColorBox color={first} />
          <Color>{first}</Color>
        </ColorWrapper>
        <ColorWrapper>
          <ColorBox color={second} />
          <Color>{second}</Color>
        </ColorWrapper>
        <ColorWrapper>
          <ColorBox color={third} />
          <Color>{third}</Color>
        </ColorWrapper>
      </ColorsWrapper>
    </Wrapper>
  )
}
